import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function SecondaryButton({ text, to , size }) {
  SecondaryButton.propTypes = {
    text: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
  };

  const navigate = useNavigate();
  const handleClick = () => {
    navigate(to);
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleClick}
      size={size}
    >
      {text}
    </Button>
  );
}

export default SecondaryButton;
